module.exports = __webpack_public_path__ + "static/img/bg-pt.c11d76ac.webp";